import PropTypes from 'prop-types';

export default function ProgressBar({ percentage, width = '100%', color }) {
  return (
    <div
      style={{
        width,
        height: 5,
        borderRadius: 5,
        backgroundColor: '#E5E5E5',
      }}
    >
      <div
        style={{
          width: `${percentage}%`,
          height: '100%',
          borderRadius: 5,
          backgroundColor: color || 'var(--color-blue-primary)',
          zIndex: 1,
        }}
      />
    </div>
  );
}

ProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired,
  width: PropTypes.string,
  color: PropTypes.string,
};
